import { SituacaoDoMacon } from './../../common/types/Irmao'
import { Loja, InputLoja } from './../../common/types/Loja'
import axios from '@/plugins/axios'
import GenericService from '@/shareds/GenericService'
import Irmao from 'common/types/Irmao'
import { ParametrosDeBusca } from 'common/types/Busca'

export const PATH_LOJA = '/lojas'

class LojaService extends GenericService<Loja, InputLoja> {
	constructor() {
		super(PATH_LOJA)
	}

	async find(params: ParametrosDeBusca = {}) {
		return super.find({
			...params,
			somar: 'Somar Itapocu',
		})
	}

	async getIrmaos(id: string, filtros: {
		situacaoDoMacon?: SituacaoDoMacon,
	}) {
		try {
			const result = await axios.get<Irmao[]>(`${this.route}/${id}/irmaos`, {
				params: {
					situacaoDoMacon: filtros.situacaoDoMacon,
				},
			})
			return result.data
		} catch (error) {
			throw error
		}
	}
}

export default new LojaService()
